var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccounts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "accounts",
    transform: "translate(-358 -47)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8422",
    "data-name": "Rectangle 8422",
    width: 38,
    height: 38,
    rx: 19,
    transform: "translate(358 47)",
    fill: "#404246"
  }), /*#__PURE__*/React.createElement("g", {
    id: "wvIKvO.tif",
    transform: "translate(-1498.197 -1587.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18102",
    "data-name": "Group 18102",
    transform: "translate(1866.035 1645.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31085",
    "data-name": "Path 31085",
    d: "M1866.035,1803.25c.034-.149.065-.3.1-.448a3.417,3.417,0,0,1,3.326-2.628c.769-.01,1.538,0,2.307,0H1872a3.387,3.387,0,0,0,1.021,2.3,4.17,4.17,0,0,0-2.34,1.829,4.811,4.811,0,0,0-.562,2.918,16.436,16.436,0,0,1-4.088-.786Z",
    transform: "translate(-1866.035 -1794.619)",
    fill: "#f8f8f8",
    stroke: "#404246",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31086",
    "data-name": "Path 31086",
    d: "M2006.713,1881.89c0,.488,0,.977,0,1.465a.2.2,0,0,1-.135.217,7.972,7.972,0,0,1-2.186.638,14.432,14.432,0,0,1-6.494-.549c-.347-.1-.347-.1-.347-.472,0-.846-.013-1.692.005-2.538a3.387,3.387,0,0,1,3.233-3.344c.939-.043,1.884-.037,2.823.007a3.379,3.379,0,0,1,2.953,2.462,6.081,6.081,0,0,1,.14,1.075C2006.731,1881.2,2006.713,1881.544,2006.713,1881.89Z",
    transform: "translate(-1992.837 -1868.965)",
    fill: "#f8f8f8",
    stroke: "#404246",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31087",
    "data-name": "Path 31087",
    d: "M2190.776,1800.468c.932,0,1.844-.073,2.74.016a3.352,3.352,0,0,1,2.955,3.215c.032.946.007,1.895.014,2.842,0,.113-.065.14-.139.175a7.46,7.46,0,0,1-2.063.616c-.521.083-1.049.128-1.6.193,0-.147,0-.259,0-.37a5.171,5.171,0,0,0-.183-1.7,4.062,4.062,0,0,0-2.551-2.659c-.05-.019-.1-.036-.181-.064A3.348,3.348,0,0,0,2190.776,1800.468Z",
    transform: "translate(-2178.163 -1794.88)",
    fill: "#f8f8f8",
    stroke: "#404246",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31088",
    "data-name": "Path 31088",
    d: "M2050.523,1725.235a2.685,2.685,0,1,1,2.673,2.685A2.684,2.684,0,0,1,2050.523,1725.235Z",
    transform: "translate(-2043.91 -1719.786)",
    fill: "#f8f8f8",
    stroke: "#404246",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31089",
    "data-name": "Path 31089",
    d: "M1921.676,1645.359a2.683,2.683,0,0,1,2.679,2.648.337.337,0,0,1-.126.291,3.27,3.27,0,0,0-1.1,1.869.348.348,0,0,1-.158.209,2.679,2.679,0,0,1-3.972-2.561A2.671,2.671,0,0,1,1921.676,1645.359Z",
    transform: "translate(-1917.089 -1645.357)",
    fill: "#f8f8f8",
    stroke: "#404246",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31090",
    "data-name": "Path 31090",
    d: "M2179.959,1648.016a2.683,2.683,0,0,1-3.687,2.472.214.214,0,0,1-.155-.186,3.26,3.26,0,0,0-1.433-2.271.212.212,0,0,1-.087-.228,2.685,2.685,0,0,1,5.362.212Z",
    transform: "translate(-2163.535 -1645.32)",
    fill: "#f8f8f8",
    stroke: "#404246",
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounts);
export default __webpack_public_path__ + "static/media/accounts.6d7e26e1caa97083b90d8ba36ecb8605.svg";
export { ForwardRef as ReactComponent };